var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var progressBar = reset;
export var inline = __assign(__assign({}, progressBar), { alignItems: 'center', display: 'flex' });
export var barWrapper = {
    background: 'transparent',
    borderRadius: 2,
    display: 'flex',
    flexGrow: 1,
    height: 20,
    position: 'relative',
};
export var barWrapperBackground = __assign(__assign({}, barWrapper), { background: '#dadada', overflow: 'hidden' });
export var small = {
    height: 10,
};
export var large = {
    height: 20,
};
export var bar = {
    borderRadius: 0,
    display: 'block',
    position: 'absolute',
    height: '100%',
    background: '#41a8d2',
    color: '#ffffff',
};
export var informational = __assign(__assign({}, bar), { background: '#41a8d2' });
export var warning = __assign(__assign({}, bar), { background: '#ff8800' });
export var complete = __assign(__assign({}, bar), { background: '#3dc270' });
export var data = __assign(__assign({}, bar), { background: '#2eab73' });
export var segmentBarWrapper = {
    background: 'transparent',
    borderRadius: 2,
    // display: 'flex',
    // flexGrow: 1,
    position: 'relative',
};
export var segmentWrapper = {
    display: 'inline-block',
};
export var segmentBlock = {
    borderRight: "1px solid ".concat('#ffffff'),
    boxSizing: 'border-box',
    height: 20,
};
export var segmentPointer = {
    borderLeft: "1px solid ".concat('#666666'),
    height: 8,
    margin: '2px 0 0 6px',
    width: 10,
};
export var segmentLabel = {
    color: '#666666',
    fontSize: 12,
    fontStyle: 'italic',
    height: 15,
    overflow: 'hidden',
    paddingRight: '4px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
export var segmentLegendWrapper = {
    display: 'inline-block',
};
export var segmentLegendTitle = {
    fontSize: 24,
    fontWeight: 700,
};
export var segmentLegendLabel = {
    fontSize: 14,
    fontWeight: 400,
};
export var header = {
    color: '#666666',
    fontSize: "".concat(12, "px !important"),
    lineHeight: 1.1,
    margin: "0 0 ".concat(4, "px 0"),
};
export var headerLarge = {
    color: '#666666',
    fontSize: "".concat(24, "px !important"),
    fontWeight: '300',
    lineHeight: 1.1,
    margin: "0 0 ".concat(4, "px 0"),
};
export var headerExtraLarge = {
    color: '#323e48',
    fontSize: "56px !important",
    fontWeight: '700',
    lineHeight: 1.1,
    margin: "0 0 6px 0",
};
export var headerInline = __assign(__assign({}, header), { display: 'flex', margin: "0 0 0 ".concat(4, "px"), minWidth: 24, overflow: 'hidden', whiteSpace: 'nowrap' });
export var headerInlineLarge = __assign(__assign({}, header), { display: 'flex', fontSize: "".concat(24, "px"), fontWeight: '300', margin: "0 0 0 ".concat(16, "px"), minWidth: 34, overflow: 'hidden', whiteSpace: 'nowrap' });
export var footnote = {
    fontSize: "".concat(12, "px !important"),
    lineHeight: 1.66,
    textAlign: 'right',
};
export var step = {
    background: '#1588af',
    borderRadius: 0,
    display: 'block',
    height: '100%',
    position: 'absolute',
    transition: "width ".concat('300ms', " cubic-bezier(0.645, 0.045, 0.355, 1.000)"),
};
export var stepProgress = __assign(__assign({}, bar), { background: '#41a8d2', transition: "width ".concat('300ms', " cubic-bezier(0.645, 0.045, 0.355, 1.000)") });
export var trendLargeWrapper = {
    margin: "0 0 0 ".concat(16, "px"),
};
export var trendSmallWrapper = {
    margin: "0 0 0 ".concat(8, "px"),
};
export var trendContent = {
    color: '#666666',
    margin: "0 0 0 ".concat(4, "px"),
};
export var trendLarge = __assign(__assign({}, trendContent), { fontSize: 16, fontWeight: 600 });
export var trendSmall = __assign(__assign({}, trendContent), { fontSize: 12, fontWeight: 600 });
export var trendHeaderWrapper = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginBottom: '4px',
};
